import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangelogService, ChangelogVersion } from './changelog.service';

@Component({
	standalone: false,
	selector: 'bp-changelog',
	templateUrl: './changelog.component.html',
	styleUrls: ['./changelog.component.css']
})
export class ChangelogComponent implements OnInit {
	versions: ChangelogVersion[] = [];

	activeModal = inject(NgbActiveModal);
	cs = inject(ChangelogService);

	ngOnInit() {
		this.versions = this.cs.versions();
		this.cs.markAsRead();
	}

	formatDate(dateStr: string): string {
		try {
			const date = new Date(dateStr);
			return date.toLocaleDateString('de-DE', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			});
		} catch {
			return dateStr;
		}
	}
}
